// src/com/arrive_charge_info/ArriveChargeInfoDict.js
import { InputType, TableColumnType } from "../../value/AppConst";
import IsValid from "../../value/IsValid";
import ValueMisc from "../../value/ValueMisc";

// DC에서 도착지까지 운임정보, arrive_charge_info
const Dict = {
    // toAdd, toEdit : mark if need to submit for mutation
    arriveId : {
		id: 'arriveId', label: '도착지',
		type: InputType.text, required: true, toAdd: true, toEdit: true,
		help: '12자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 12)},
	}, // varchar(12)
    vehTypeId : {
		id: 'vehTypeId', label: '차종',
		type: InputType.select, required: true, toAdd: true, toEdit: true,
        labelKey: 'vehTypeName',
		help: '10자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 10)},
	}, // varchar(10)
    charge : {
		id: 'charge', label: '운임(원)',
		type: InputType.number, required: true, toAdd: true, toEdit: true,
		check: (value) => {return value > 0 && value <= 99999999},
	}, // int(11)
    addCharge : {
		id: 'addCharge', label: '추가 운임',
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= 0 && value <= 99999999},
	}, // int(11)
    regTypeCd : {
		id: 'regTypeCd', label: '등록구분',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '1자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 1)},
	}, // enum('R','A','M')
};

/**
 * ARRIVE_CHARGE_INFO React Component Dictionary for Input and Output
 * Project: NewTOP for cloud
 * 2026-04-30 16:21:46 using DbdbTap
 * https://www.dbdbtap.com
 */
export const ArriveChargeInfoDictionary = {
    inputMap: Dict,
    errorTitle: {
        Add: '운임정보 등록 오류',
        Edit: '운임정보 수정 오류',
        Remove: '운임정보 삭제 오류',
        Get: '운임정보 조회 오류',
    },
    tableProps: {
        tableId: 'arriveChargeInfoTable',
        uniqueKey: 'vehTypeId',
        flexOption: {
            multiChecker:false,
            hideFirstTopButton: false,
            hideColumnConfig: true,
            hideBubble: false,
            growToFill: true,
        },
        columns: [
            //print using getTableColumnOption(c,t,i)
            //{ id: 'arriveId', label: Dict.arriveId.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            // { id: 'vehTypeId', label: Dict.vehTypeId.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'vehTypeName', label: '차종', width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'charge', label: Dict.charge.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            //{ id: 'addCharge', label: Dict.addCharge.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'useYn', label: '사용구분', width: 120, show: true, option:{align: 'center', print:(r,i,v)=>v==='Y'?'사용':'사용중지'} },
            { id: 'regTypeCd', label: Dict.regTypeCd.label, width: 120, show: true, option:{align: 'center', print:(r,i,v)=>v==='A'?'자동':'수동'} },
            { id: 'updateDate', label: "등록일", width: 120, show: true, option:{align: 'center', print:(r,i,v)=>ValueMisc.substr(v,0,10)} },
            //{ id: 'updateUser', label: "updateUser", width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            //{ id: 'regDate', label: "regDate", width: 120, show: true, option:{align: 'inherit', type:TableColumnType.DATETIME} },
            //{ id: 'regUser', label: "regUser", width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'regUserName', label: "등록자", width: 80, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
        ]
    },
    uploadTableProps: {
        tableId: 'arriveChargeInfoUploadTable',
        uniqueKey: 'vehTypeId',
        flexOption: {
            multiChecker:false,
            hideFirstTopButton: true,
            hideColumnConfig: true,
            hideBubble: true,
            growToFill: true,
        },
        columns: [
            { id: 'dcCd', label: '출발지코드', width: 60, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'storeId', label: '도착지코드(점포)', width: 80, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'vehTypeId', label: '차종코드', width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'charge', label: Dict.charge.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'message', label: '메시지', width: 200, show: true, option:{align: 'left', type:TableColumnType.TEXT} },
        ]
    },
};
